import { formData, authApi } from 'utils'

export const getListServers = () => () =>
    authApi.get(`/discord/self_servers`)
        .then(res => {
          return res
        })
        .catch(err => {
          throw err
        })

export const getListRoles = (id) => () =>
    authApi.get(`/discord/server_roles?server_id=${id}`)
        .then(res => {
          if(res.status === 200){
            return res;
          }else{
            throw res;
          }
        })
        .catch(err => {
          throw err
        })